const auxil = (props: any) => props.children;

export default auxil;